export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const CHANGE_LANG = "CHANGE_LANG";
export const CHANGE_PROFILE = "CHANGE_PROFILE";